import React, { useEffect, useState } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { grid } from "@mui/system";
import { parse } from "postcss";

const ToothPosition = React.memo(({
  toothGridInitialRendering,
  gridLetters,
  toothGridData,
  setToothGridData,
}) => {
  const [selectedGridLetters, setselectedGridLetters] = useState();
  const [alignment, setAlignment] = useState(selectedGridLetters);

  useEffect(() => {
    if (gridLetters?.length > 0) {
      const firstValue = gridLetters.split(",").map((item) => item.trim())[0];
      setselectedGridLetters(firstValue);
    }

    if (toothGridInitialRendering?.current <= 1) {
      toothGridInitialRendering.current += 1;
    }
    else {
      resetGrid();
    }
  }, [gridLetters]);

  const GridDate = (index, islink = false) => {
    var toothCellObj = {
      index: parseInt(index),
      gridLetter: selectedGridLetters,
      isLink: islink,
    };

    setToothGridData((prevData) => {
      const existingItemIndex = prevData.findIndex(
        (item) => item.index == index
      );
      if (existingItemIndex !== -1) {
        const updatedData = prevData.filter((item) => item.index != index);
        return updatedData;
      } else {
        return [...prevData, toothCellObj];
      }
    });
  };

  const UpdateLinkStatus = (index, nextIndex) => {
    const isCurrentIndexPresent = toothGridData.some(
      (item) => item.index === index
    );
    const isNextIndexPresent = toothGridData.some(
      (item) => item.index === nextIndex
    );

    // If both indices are present, update the isLink of the current index to true
    if (isCurrentIndexPresent && isNextIndexPresent) {
      setToothGridData((prevData) => {
        return prevData.map((item) => {
          // Check if the current item is the one with the matching index
          if (item.index === index) {
            return {
              ...item,
              isLink: !item?.isLink,
            };
          }
          return item;
        });
      });
    }
  };

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  const [formats, setFormats] = React.useState("");

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };

  const resetGrid = () => {
    setToothGridData([]);
  };

  const IsIndexSelected = (value) => {
    return (
      toothGridData?.find((item) => item.index == parseInt(value)) !== undefined
    );
  };

  const IsLinkedIndexSelected = (index, nextIndex) => {
    const currentItem = toothGridData?.find(
      (item) => item.index === parseInt(index)
    );
    const nextItem = toothGridData?.find(
      (item) => item.index === parseInt(nextIndex)
    );

    if (currentItem && nextItem) {
      return currentItem.isLink;
    }
    return false;
  };

  return (
    <div>
      {/* please hide it in print format */}
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center justify-between">
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="text alignment"
            className="gap-2 flex-wrap"
          >
            {gridLetters?.length > 0 &&
              (gridLetters ?? "")
                .split(",")
                .map((item) => item.trim())
                .map((data, index) => (
                  <ToggleButton
                    index={index}
                    value={data}
                    onClick={(e) => {
                      setselectedGridLetters((prevValue) => {
                        // If prevValue is already the same as the current value, return the previous value
                        // This prevents setting it to null or the same value again.
                        if (prevValue === e.target.value) {
                          return prevValue; // Keep the current value unchanged
                        }
                        // Otherwise, set it to the clicked value
                        return e.target.value;
                      });
                    }}
                    selected={selectedGridLetters == data}
                    className="!rounded-full w-7 3xl:w-9 h-7 3xl:h-9 !text-[10px] 3xl:!text-xl !text-blue !bg-white border !border-blue  !font-roboto !font-medium"
                  >
                    {data}
                  </ToggleButton>
                ))}
          </ToggleButtonGroup>
        </div>
        <button
          className="px-2 py-1 leading-tight text-xs 3xl:text-sm border uppercase border-blue-500 text-blue font-robotoBold rounded-md hover:bg-blue-800 hover:border-blue-800 hover:text-white transition duration-300"
          onClick={(e) => {
            e.preventDefault();
            resetGrid();
          }}
        >
          Zurücksetzten
        </button>
      </div>
      <div className="mt-5">
        <div className="flex items-center">
          <ToggleButtonGroup
            value={formats}
            onChange={handleFormat}
            className="tooth_position"
          >
            <div>
              {/* use this css for diable section : pointer-events-none */}
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">18</p>
                    <ToggleButton
                      value="18"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(18)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 18)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot1"
                      className="!p-0 !rounded-full w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(18, 17)}
                      selected={IsLinkedIndexSelected(18, 17)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">17</p>
                    <ToggleButton
                      value="17"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(17)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 17)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot2"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(17, 16)}
                      selected={IsLinkedIndexSelected(17, 16)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">16</p>
                    <ToggleButton
                      value="16"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(16)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 16)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot3"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(16, 15)}
                      selected={IsLinkedIndexSelected(16, 15)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">15</p>
                    <ToggleButton
                      value="15"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(15)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 15)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot4"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(15, 14)}
                      selected={IsLinkedIndexSelected(15, 14)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">14</p>
                    <ToggleButton
                      value="14"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(14)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 14)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot5"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(14, 13)}
                      selected={IsLinkedIndexSelected(14, 13)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">13</p>
                    <ToggleButton
                      value="13"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(13)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 13)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot6"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(13, 12)}
                      selected={IsLinkedIndexSelected(13, 12)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">12</p>
                    <ToggleButton
                      value="12"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(12)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 12)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot7"
                      className="!p-0 !rounded-full w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(12, 11)}
                      selected={IsLinkedIndexSelected(12, 11)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">11</p>
                    <ToggleButton
                      value="11"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(11)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 11)
                          ?.gridLetter
                      }
                    </ToggleButton>
                  </div>
                </div>
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">21</p>
                    <ToggleButton
                      value="21"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(21)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 21)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot8"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(21, 22)}
                      selected={IsLinkedIndexSelected(21, 22)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">22</p>
                    <ToggleButton
                      value="22"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(22)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 22)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot9"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(22, 23)}
                      selected={IsLinkedIndexSelected(22, 23)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">23</p>
                    <ToggleButton
                      value="23"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(23)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 23)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot10"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(23, 24)}
                      selected={IsLinkedIndexSelected(23, 24)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">24</p>
                    <ToggleButton
                      value="24"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(24)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 24)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot11"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(24, 25)}
                      selected={IsLinkedIndexSelected(24, 25)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">25</p>
                    <ToggleButton
                      value="25"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(25)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 25)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot12"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(25, 26)}
                      selected={IsLinkedIndexSelected(25, 26)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">26</p>
                    <ToggleButton
                      value="26"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(26)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 26)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot13"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(26, 27)}
                      selected={IsLinkedIndexSelected(26, 27)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">27</p>
                    <ToggleButton
                      value="27"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(27)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 27)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <ToggleButton
                      value="dot14"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] bottom-2"
                      onClick={() => UpdateLinkStatus(27, 28)}
                      selected={IsLinkedIndexSelected(27, 28)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <p className="text-gray-600 text-xs text-center">28</p>
                    <ToggleButton
                      value="28"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(28)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 28)
                          ?.gridLetter
                      }
                    </ToggleButton>
                  </div>
                </div>
              </div>
              {/* use this css for diable section : pointer-events-none */}
              <div className="flex items-center justify-between gap-4 mt-5">
                <div className="flex items-center font-interRegular">
                  <div className="relative pr-1">
                    <ToggleButton
                      value="48"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(48)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 48)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">48</p>
                    <ToggleButton
                      value="dot22"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(48, 47)}
                      selected={IsLinkedIndexSelected(48, 47)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="47"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(47)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 47)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">47</p>
                    <ToggleButton
                      value="dot23"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(47, 46)}
                      selected={IsLinkedIndexSelected(47, 46)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="46"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(46)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 46)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">46</p>
                    <ToggleButton
                      value="dot24"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(46, 45)}
                      selected={IsLinkedIndexSelected(46, 45)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="45"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(45)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 45)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">45</p>
                    <ToggleButton
                      value="dot25"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(45, 44)}
                      selected={IsLinkedIndexSelected(45, 44)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="44"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(44)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 44)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">44</p>
                    <ToggleButton
                      value="dot26"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(44, 43)}
                      selected={IsLinkedIndexSelected(44, 43)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="43"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(43)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 43)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">43</p>
                    <ToggleButton
                      value="dot27"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(43, 42)}
                      selected={IsLinkedIndexSelected(43, 42)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="42"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(42)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 42)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">42</p>
                    <ToggleButton
                      value="dot28"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(42, 41)}
                      selected={IsLinkedIndexSelected(42, 41)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="41"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(41)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 41)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">41</p>
                  </div>
                </div>
                <div className="flex items-center  font-interRegular">
                  <div className="relative pr-1">
                    <ToggleButton
                      value="31"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(31)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 31)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">31</p>
                    <ToggleButton
                      value="dot15"
                      className="!p-0 !rounded-full  w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(31, 32)}
                      selected={IsLinkedIndexSelected(31, 32)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="32"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(32)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 32)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">32</p>
                    <ToggleButton
                      value="dot16"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(32, 33)}
                      selected={IsLinkedIndexSelected(32, 33)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="33"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(33)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 33)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">33</p>
                    <ToggleButton
                      value="dot17"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(33, 34)}
                      selected={IsLinkedIndexSelected(33, 34)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="34"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(34)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 34)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">34</p>
                    <ToggleButton
                      value="dot18"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(34, 35)}
                      selected={IsLinkedIndexSelected(34, 35)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="35"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(35)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 35)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">35</p>
                    <ToggleButton
                      value="dot19"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(35, 36)}
                      selected={IsLinkedIndexSelected(35, 36)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="36"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(36)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 36)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">36</p>
                    <ToggleButton
                      value="dot20"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(36, 37)}
                      selected={IsLinkedIndexSelected(36, 37)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="37"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(37)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 37)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">37</p>
                    <ToggleButton
                      value="dot21"
                      className="!p-0 !rounded-full   w-[9px] h-[9px] border-0 !bg-gray-400 !absolute -right-[2px] z-[1] top-[10px]"
                      onClick={() => UpdateLinkStatus(37, 38)}
                      selected={IsLinkedIndexSelected(37, 38)}
                    ></ToggleButton>
                  </div>
                  <div className="relative pr-1">
                    <ToggleButton
                      value="38"
                      onClick={(e) => {
                        GridDate(e.target.value);
                      }}
                      selected={IsIndexSelected(38)}
                      className="!p-0 !rounded-full w-6 h-6 !text-[9px] !text-transparent !border !border-gray-500"
                    >
                      {
                        toothGridData?.find((item) => item.index == 38)
                          ?.gridLetter
                      }
                    </ToggleButton>
                    <p className="text-gray-600 text-xs text-center">38</p>
                  </div>
                </div>
              </div>
            </div>
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );
});

export default ToothPosition;
